module.exports = __webpack_public_path__ + "static/media/plus.e80ed374.svg";